/* Admiral-style addon enhancements — scoped to product-with-modal pages.
   - Inject (N) item counts into filter chips and mobile select
   - Mark "All" chip active on load
   - Initialise slick carousel for the addon grid
   - Reinit slick after each filter change

   Defer-loaded; runs after product-v3.liquid's inline filter handler is
   registered, so our jQuery handlers fire AFTER v3's existing logic. */

(function () {
  if (typeof jQuery === 'undefined') return;

  jQuery(function ($) {
    if (!$('body').hasClass('product-product-with-modal')) return;

    var $tags = $('.add_on_tags');
    var $mobileSelect = $('.add_on_tags_mobile');
    var $items = $('.addon-item[data-product-type="addon"]');
    var $sliderWrap = $('.addon.checkbox-addons.checkbox-addons--default');

    // ------ 1. Compute and inject category counts ------
    function countByTag(tag) {
      if (tag === 'all') return $items.length;
      // data-tag is comma-separated; v3 chip values match individual tag tokens
      return $items.filter(function () {
        var dataTag = ($(this).attr('data-tag') || '').toLowerCase();
        return dataTag.indexOf(tag.toLowerCase()) !== -1;
      }).length;
    }

    $tags.find('li').each(function () {
      var $li = $(this);
      var tag = ($li.data('tag') || '').toString();
      var count = countByTag(tag);
      var label = $li.text().replace(/\s*\(\d+\)\s*$/, '');
      $li.text(label + (count > 0 ? ' (' + count + ')' : ''));
      if (count === 0) $li.addClass('is-empty');
    });

    $mobileSelect.find('option').each(function () {
      var $opt = $(this);
      var tag = ($opt.attr('value') || '').toString();
      var count = countByTag(tag);
      var label = $opt.text().replace(/\s*\(\d+\)\s*$/, '');
      $opt.text(label + (count > 0 ? ' (' + count + ')' : ''));
    });

    // ------ 2. Mark "All" chip active by default ------
    if (!$tags.find('li.active').length) {
      $tags.find('li[data-tag="all"]').addClass('active');
    }

    // ------ 3. Slick carousel ------
    function slickAvailable() {
      return typeof $.fn.slick === 'function';
    }

    function destroyModalSlick() {
      try {
        if ($sliderWrap.hasClass('slick-initialized')) {
          $sliderWrap.slick('unslick');
        }
      } catch (e) { /* swallow */ }
    }

    function initModalSlick() {
      if (!slickAvailable() || !$sliderWrap.length) return;
      if ($sliderWrap.hasClass('slick-initialized')) return;
      try {
        $sliderWrap.slick({
          arrows: true,
          infinite: false,
          slidesToShow: 10,
          slidesToScroll: 3,
          slide: '.addon-item:not(.modal-hidden)',
          responsive: [
            { breakpoint: 1400, settings: { slidesToShow: 10 } },
            { breakpoint: 1180, settings: { slidesToShow: 8 } },
            { breakpoint: 1000, settings: { slidesToShow: 5 } },
            { breakpoint: 768,  settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 480,  settings: { slidesToShow: 2, slidesToScroll: 1 } }
          ]
        });
      } catch (e) {
        console.warn('[wwd-modal] slick init failed:', e);
      }
    }

    // Wait until slick CDN script has finished loading (it's deferred)
    if (slickAvailable()) {
      initModalSlick();
    } else {
      // Poll briefly for slick (CDN script may load slightly after DOMContentLoaded)
      var attempts = 0;
      var iv = setInterval(function () {
        attempts++;
        if (slickAvailable()) {
          clearInterval(iv);
          initModalSlick();
        } else if (attempts > 40) { // ~4 seconds
          clearInterval(iv);
        }
      }, 100);
    }

    // ------ 4. Filter handling (replaces v3's inline display:none-based filter) ------
    // v3's inline handler hides items via display:none — slick ignores that and keeps
    // showing them. Unbind v3's handler on this template only and use a class-based
    // hide so slick can filter via `slide: '.addon-item:not(.modal-hidden)'`.
    $('.add_on_tags li').off('click');
    $('.add_on_tags_mobile').off('change');

    function applyTagFilter(tag) {
      var $items = $('.product-product-with-modal .addon-item[data-product-type="addon"]');
      $items.removeClass('modal-hidden').css('display', '');
      if (tag && tag !== 'all') {
        var needle = 'tag:' + tag;
        $items.each(function () {
          var dataTag = ($(this).attr('data-tag') || '').toLowerCase();
          if (dataTag.indexOf(needle.toLowerCase()) === -1) {
            $(this).addClass('modal-hidden');
          }
        });
      }
      destroyModalSlick();
      initModalSlick();
    }

    $(document).on('click', '.product-product-with-modal .add_on_tags li', function () {
      var $li = $(this);
      if ($li.hasClass('is-empty')) return;
      var tag = ($li.data('tag') || '').toString();

      if ($li.hasClass('active') && tag !== 'all') {
        // Clicking an active non-"All" chip → reset to "All"
        $('.product-product-with-modal .add_on_tags li').removeClass('active');
        $('.product-product-with-modal .add_on_tags li[data-tag="all"]').addClass('active');
        applyTagFilter('all');
      } else {
        $('.product-product-with-modal .add_on_tags li').removeClass('active');
        $li.addClass('active');
        applyTagFilter(tag);
      }
    });

    $(document).on('change', '.product-product-with-modal .add_on_tags_mobile', function () {
      var tag = ($(this).val() || '').toString();
      applyTagFilter(tag);
    });

    // ------ 5. Click anywhere on a card to select/deselect ------
    // Proxy the click to the existing .link_hover (select) or .image_hover (deselect)
    // handlers in product-v3.js so we don't duplicate state-management logic.
    $(document).on('click', '.product-product-with-modal .addon-item', function (e) {
      var $target = $(e.target);
      // Don't intercept clicks on interactive children — they have their own handlers.
      if ($target.closest('#view-details-addon, .see-more, .addon-qty-container, .link_hover, .image_hover').length) {
        return;
      }
      var $item = $(this);
      if ($item.hasClass('active')) {
        $item.find('.image_hover').trigger('click');
      } else {
        $item.find('.link_hover').trigger('click');
      }
    });

    // ------ 6. ADD TO CART wiring ------
    // No proxy needed: #v3-main-cta and #v3-sticky-btn both already carry the
    // .global-button class, and product-v3.js:384 has a delegated
    // $(document).on("click", ".global-button", ...) handler that runs the
    // full validation + addItemsToCart() flow. A previous proxy here caused a
    // double-submit (one from the click on #v3-main-cta, one from the
    // .trigger('click') it bubbled into the real form button — which also
    // carries .global-button) and ended up with quantity: 2 line items in cart.
    // Don't add a handler here.
  });
})();
